import * as React from 'react';

import classnames from 'classnames';

import styles from './sidebar-header.module.css';

type Props = {
    label: string | React.ReactNode;
    isTopHeader?: boolean;
};

export function SidebarHeader(props: Props) {
    const headerLabel = typeof props.label === 'string' ? props.label.toUpperCase() : props.label;

    const styleNames = classnames(styles['sidebar-header-container'], {
        [styles['sidebar-header-container--top']]: props.isTopHeader,
    });

    return <div className={styleNames}>{headerLabel}</div>;
}
